import React from 'react';
import style from './FAQ.module.css';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../components/headersStyling.css';
import { useTranslation } from 'react-i18next';
import Loading from '../../components/Loading/Loading';
import NoData from '../../components/NoData/NoData';
import { getFaqs } from './../../Api/staticPage';
import { filterLanguage } from './../../utilities/filterFunction';
import { imgResize } from './../../utilities/imageResize';
import { basename } from './../../configiration/config';

function FAQ() {
    const [t] = useTranslation();
    const [loading, setLoading] = useState(true);
    const [faqs, setFaqs] = useState([]);
    const [faqImage, setfaqImage] = useState([]);
    let navigate = useNavigate();

    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    useEffect(() => {
        getFaqs().then(response => {
                if (response.data.status === true) {
                    if (response.data.data && response.data.data.image) {
                        setfaqImage(response.data.data.image)
                    }
                    if (response.data.data && response.data.data.faq) {
                        setFaqs(response.data.data.faq)
                    }
                }
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
        // eslint-disable-next-line
    }, []);
    return (
        <div>
            {/* START OF HEADER SECTION */}
            {faqImage && 
            <div className={`myHeader d-flex align-items-center justify-content-center`} style={{ backgroundImage: `url(${imgResize(faqImage,1920,0)})` }}>
                <div className={`myHeaderContent`}>
                    <h1>{t('faqs')}</h1>
                    <p><span className='homeWord' onClick={() => { navigate(`${basename}/`) }}>{t('home')}</span> / {t('faq')}</p>
                </div>
            </div>
            }
            {/* END OF HEADER SECTION */}

            <div className={`${style.myCustomContainer} mb-5`}>
                {/* START OF FAQs SECTION */}
                <div className={`${style.faqContainer} pt-4`}>
                    <div className={`${style.faqAccordion}`}>
                        <div className="accordion" id="accordionExample">
                            {faqs && faqs.length > 0 && faqs.map((faq) => {
                                let selectedFaq=filterLanguage(faq.locales)
                                return (
                                    <div key={faq.slug} className={`${style.accordionItem} accordion-item`}>
                                        <h2 className="accordion-header" id="headingOne">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse_${faq.slug}`} aria-expanded="false" aria-controls={`collapse_${faq.slug}`}>
                                            {selectedFaq.length > 0 && selectedFaq[0].question}
                                            </button>
                                        </h2>
                                        <div id={`collapse_${faq.slug}`} className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                            <div className={`${style.accordionBody} accordion-body`}>
                                                <p>{selectedFaq.length > 0 && selectedFaq[0].answer}</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                            }
                        </div>
                    </div>
                </div>
                {loading &&
                    <Loading width='100px' height='100px' />
                }
                {!loading && !faqs && faqs.length<0 &&
                    <NoData text='No available data' />
                }
                {/* END OF CONTACT INFO SECTION */}
            </div>
        </div>
    )
}

export default FAQ